<div id="topNav">
  <mat-toolbar color="primary"
               #toolbar
               style="height: 50px; padding-left: 9px;">
    <button mat-icon-button
            class="toolbar-icon-button"
            data-top-menu-action="navigation"
            (click)="toggleMinMaxLeftMenu()"
            style="float: left; margin-top: 2px; margin-left: -9px; margin-right: 8px; color: #ccc;">
      <fa-icon [icon]="faBars"
               style="font-size: 0.85rem;"
               [fixedWidth]="true"></fa-icon>
    </button>
    <span class="navbar-brand"
          style="display: inline-block; width: 115px; margin-left: -5px;"
          (click)="goHome()">
      <img src="assets/img/logo-white-40w.png"
           fetchpriority="high"
           style="width: 30px; margin-top: -4px; margin-right: -5px;" /> &nbsp;CUB </span>
    <span class="fill-space"></span>
    <span *ngIf="daysPasswordExpiresIn() <= 15">
      <button mat-button
              matTooltip="Password Expiring Soon - Click to Update"
              (click)="openPasswordChange()"
              style="margin-right: 10px; color: #f0ad4e;">
        <fa-icon [icon]="faExclamationTriangle"
                 class="fa-lg"
                 style="margin-right: 5px;"></fa-icon> {{ getPasswordMessage() }} </button>
    </span>
    <div #searchAnchor
         class="search-anchor">
      <form class="form-inline mt-2 mt-md-0 search-form"
            [class.on-search-page]="isSearchPage"
            [class.slide-ready]="slideReady"
            [style.left.px]="searchBoxLeft">
        <input #searchBox
               id="searchBox"
               name="searchBox"
               class="form-control"
               type="search"
               placeholder="Enterprise Search"
               autocomplete="off"
               autocorrect="off"
               autocapitalize="off"
               spellcheck="false"
               (mousedown)="openSearch()"
               (keydown)="onSearchKeyDown($event)"
               (keyup)="onKeyUp($event)"
               (search)="onKeyUp($event)"
               (blur)="onSearchBlur()">
      </form>
    </div>
    <div style="float: right;">
      <button id="btnYardi"
              mat-icon-button
              matTooltip="Yardi"
              (click)="openYardiOne()"
              style="margin-right: 6px;">
        <img src="../../../assets/img/yardi-white.png"
             style="width: 24px; vertical-align: middle; margin-top: -10px;" />
      </button>
      <button id="btnPowerBI"
              mat-icon-button
              matTooltip="Open Power BI"
              [matMenuTriggerFor]="powerBiMenu"
              (menuOpened)="getPowerBIReports()"
              data-top-menu-action="power-bi"
              style="margin-right: 6px;">
        <img src="../../../assets/img/powerbi-logo-white.png"
             style="width: 20px; height: 20px; vertical-align: middle; margin-top: -12px;" />
      </button>
      <mat-menu #powerBiMenu="matMenu"
                [yPosition]="'below'"
                [xPosition]="'before'"
                [overlapTrigger]="false">
        <button mat-menu-item
                (click)="openPowerBI()"> Go to Power BI </button>
        <hr class="menu-separator" />
        <button mat-menu-item
                *ngIf="powerBILoadState === 'loading'"
                data-power-bi-state="loading"
                disabled>Loading...</button>
        <button mat-menu-item
                *ngIf="powerBILoadState === 'error'"
                data-power-bi-state="error"
                (click)="getPowerBIReports(); $event.stopPropagation()">Reports unavailable. Retry</button>
        <button mat-menu-item
                *ngIf="powerBILoadState === 'loaded' && powerBIWorkspaces.length === 0"
                data-power-bi-state="empty"
                disabled>No reports available</button>
        <button mat-menu-item
                *ngFor="let workspace of powerBIWorkspaces"
                [attr.data-power-bi-workspace]="workspace.id"
                [matMenuTriggerFor]="workspaceMenu"
                (menuOpened)="getReportsInWorkspace(workspace.id)"> {{ workspace.name }} </button>
      </mat-menu>
      <mat-menu #workspaceMenu="matMenu"
                [yPosition]="'below'"
                [xPosition]="'after'"
                [overlapTrigger]="false">
        <button mat-menu-item
                *ngFor="let report of reportsInWorkspace"
                [attr.data-power-bi-report]="report.id"
                (click)="openPowerBIReport(report)"> {{ report.name }} </button>
      </mat-menu>
      <button id="btnOffice"
              mat-icon-button
              matTooltip="Open Microsoft 365"
              (click)="openOffice()"
              style="margin-right: 6px;">
        <img src="../../../assets/img/office-logo-white.png"
             style="width: 16px; height: 18px; vertical-align: middle; margin-top: -12px;" />
      </button>
      <button id="btnSharepoint"
              mat-icon-button
              matTooltip="Open SharePoint"
              (click)="openSharePoint()"
              style="margin-right: 6px;">
        <img src="../../../assets/img/sharepoint-logo-white-100x.png"
             style="width: 20px; height: 20px; vertical-align: middle; margin-top: -12px;" />
      </button>
      <button id="btnEgnyte"
              mat-icon-button
              matTooltip="Open Egnyte"
              (click)="openEgnyte()"
              style="margin-right: 6px;">
        <img src="../../../assets/img/egnyte-logo-white.png"
             style="width: 20px; height: 20px; vertical-align: middle; margin-top: -12px;" />
      </button>
    </div>
    <div style="float: right; border-right: solid 1px #425582; margin: 20px 10px 20px 0;">
      &nbsp;
    </div>
    <button id="badData"
            mat-icon-button
            class="toolbar-icon-button"
            data-top-menu-action="help"
            matBadge="{{ badDataCount }}"
            matBadgeHidden="{{ badDataCount === 0 }}"
            matBadgePosition="after"
            matBadgeSize="small"
            matBadgeColor="warn"
            [matMenuTriggerFor]="badDataMenu"
            [disabled]="badDataDisabled"
            matTooltip="Help / Bad Data"
            style="margin-right: 5px; font-size: 0.8rem;">
      <fa-icon [icon]="faQuestionSquare"
               style="float: right; font-size: 1.0rem;"
               [fixedWidth]="true"></fa-icon>
    </button>
    <mat-menu #badDataMenu="matMenu"
              [yPosition]="'below'"
              [xPosition]="'after'"
              [overlapTrigger]="false">
      <div class="group-label"
           style="margin-top: -8px;">Help</div>
      <button mat-menu-item
              (click)="openHelp()">
        <fa-icon [icon]="faQuestionSquare"
                 style="font-size: 1.0rem; margin-right: 5px;"
                 [fixedWidth]="true"></fa-icon>
        General Help
      </button>
      <button mat-menu-item
              (click)="openMISHelp()">
        <fa-icon [icon]="faLaptopMedical"
                 style="font-size: 1.0rem; margin-right: 5px;"
                 [fixedWidth]="true"></fa-icon>
        MIS Help
      </button>
      <button mat-menu-item
              (click)="openSendToEmailWindow()">
        <fa-icon [icon]="faEnvelope"
                 style="font-size: 1.0rem; margin-right: 5px;"
                 [fixedWidth]="true"></fa-icon>
        Email MIS
      </button>
      <div class="group-label">Bad Data</div>
      <button mat-menu-item
              (click)="openBadDataTicket()">
        <fa-icon [icon]="faBullhorn"
                 style="font-size: 1.0rem; margin-right: 5px;"
                 [fixedWidth]="true"></fa-icon>
        Report Bad Data </button>
      <button mat-menu-item
              (click)="openBadDataListing()">
        <fa-icon [icon]="faListCheck"
                 style="font-size: 1.0rem; margin-right: 5px;"
                 [fixedWidth]="true"></fa-icon>
        View Listing </button>
    </mat-menu>
    <button mat-icon-button
            class="toolbar-icon-button"
            data-top-menu-action="recents"
            [matMenuTriggerFor]="recentMenu"
            style="margin-right: 0px;"
            (click)="logClick('Recents');">
      <fa-icon [icon]="faHistory"
               style="font-size: 1.0rem;"
               [fixedWidth]="true"></fa-icon>
    </button>
    <mat-menu #recentMenu="matMenu"
              [yPosition]="'below'"
              [xPosition]="'before'"
              [overlapTrigger]="false">
      <div *ngFor="let item of recents; let i = index">
        <div class="group-label"
             [style.marginTop.px]="i === 0 ? -8 : 0"
             *ngIf="item.subMenu.length > 0">{{ item.name }}</div>
        <div *ngIf="item.subMenu.length > 0"
             style="">
          <cub-menu-item *ngFor="let item of item.subMenu"
                         [menuItem]="item"
                         [tooltip]="item.itemType || ''">
          </cub-menu-item>
        </div>
      </div>
    </mat-menu>
    <button mat-icon-button
            [matMenuTriggerFor]="userMenu"
            style="">
      <img *ngIf="user"
           [src]="getPhotoUrl()"
           style="width: 30px; height: 30px; border-radius: 28px; margin-top: -3px;" />
    </button>
    <mat-menu #userMenu="matMenu"
              style="margin-top: 10px;"
              [yPosition]="'below'"
              [xPosition]="'before'"
              [overlapTrigger]="false">
      <cub-menu-item *ngFor="let item of userMenuList"
                     [menuItem]="item"></cub-menu-item>
      <cub-menu-item [menuItem]="logoutMenuItemSep"></cub-menu-item>
      <cub-menu-item [menuItem]="logoutMenuItem"
                     (menuClicked)="userMenuItemClicked($event)"></cub-menu-item>
    </mat-menu>
  </mat-toolbar>
</div>
